import { render, staticRenderFns } from "./FrontCard.vue?vue&type=template&id=c3ba72e8&scoped=true&"
import script from "./FrontCard.vue?vue&type=script&lang=js&"
export * from "./FrontCard.vue?vue&type=script&lang=js&"
import style0 from "./FrontCard.vue?vue&type=style&index=0&id=c3ba72e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3ba72e8",
  null
  
)

export default component.exports